import page from "./page";
import validation from "./validation";
export const TRANSLATIONS_MM = {
  page,
  validation,
};
